module.exports = __webpack_public_path__ + "img/logo-blogs.82ce4db9.svg";